import { render, staticRenderFns } from "./DateInProgress.vue?vue&type=template&id=0b963504&"
import script from "./DateInProgress.vue?vue&type=script&lang=js&"
export * from "./DateInProgress.vue?vue&type=script&lang=js&"
import style0 from "./DateInProgress.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports